import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import BigTextFieldWidgetUtil from "@/utils/editView/widgets/BigTextFieldWidgetUtil.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import FieldToFocusUtils from "@/utils/common/FieldToFocusUtils.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import {Ref} from "vue";
import {QInput} from "quasar";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import errorSound from "@/assets/sounds/error-03-125761.mp3";
import FieldMetaData = namaTypes.FieldMetaData;

export default class BarcodeTextFieldWidgetUtil extends BigTextFieldWidgetUtil {

  constructor(presenter: WidgetsPresenter, fieldMetaData: FieldMetaData) {
    super(presenter, fieldMetaData)
  }

  public async insertBarcode(qInputRef: Ref<QInput | null>) {
    let barcodes: string[] = (this.inputFieldValueRef.value as string).split("\n").filter(l => l.trim() !== "");
    this.inputFieldValueRef.value = "";
    useNamaFlagsStore().setDoNotFocusColumn(true);
    try {
      for (let code of barcodes) {
        await this.parseBarcode(code);
      }
    } finally {
      if (qInputRef.value) {
        qInputRef.value.focus();
      }
      useNamaFlagsStore().setDoNotFocusColumn(false);
    }
  }

  public async parseBarcode(barcode: string) {
    let colId = "details.item.itemCode";
    let details: any[] = this.presenter.fetchRecord()?.details;
    let rowIndex: number = this.presenter.fetchRecord()?.details?.length ? this.presenter.fetchRecord()?.details?.length - 1 : 0;
    if (details && details[rowIndex].item?.itemCode && AGGridUtils.canAppendRow(this.presenter, colId)) {
      let id = await ClientCache.asyncNextGUIDId();
      this.presenter.fetchRecord()?.details.push({id, g2Id: id});
      rowIndex++;
    }
    NamaCommon.setFieldValue(this.presenter.fetchRecord(), colId, barcode, rowIndex);
    await FieldToFocusUtils.focusToField(new FieldToFocusUtils(this.presenter as EditPresenter), colId, rowIndex);
    await this.colPostAction(colId, rowIndex);
    this.addNotProcessedBarcode(barcode);
  }

  private addNotProcessedBarcode(barcode: string) {
    if (!barcode.trim())
      return;
    let find = this.presenter.fetchRecord()?.details.find(l => l.item.itemCode === barcode);
    if (!find) {
      const audio = new Audio(errorSound);
      audio.volume = 0.5;
      audio.play().catch(err => console.error('Failed to play warning sound:', err));
      let invalidBarcodes = this.presenter.fetchRecord().invalidBarcodes ?? '';
      NamaCommon.setFieldValue(this.presenter.fetchRecord(), "invalidBarcodes", invalidBarcodes + barcode + "\n");
    }
  }

  private async colPostAction(colId: string, rowIndex: number) {
    if (this.presenter.fetchDispatcher())
      await this.presenter.fetchDispatcher().validateColumn(colId, rowIndex, false);
  }
}
